import React from 'react';
import { motion } from 'framer-motion';
const DRA_LOGO = 'https://cdn.magicpatterns.com/uploads/wkgK3TfUfV2kt1gG4bGoYo/logo_Dra_Ysalismar.png';
const PROFEM_LOGO = 'https://cdn.magicpatterns.com/uploads/dVddGeVW64T3Smy2i85CP7/Logo_Centro_medico_Especializado_Profem.jpg';
export function SponsorClosing() {
  return <section className="py-16 md:py-20 px-4 bg-bg-secondary" data-id="element-241">
      <div className="max-w-3xl mx-auto text-center" data-id="element-242">
        <motion.p className="italic text-body text-base md:text-lg mb-10 leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-243">
          Una guía creada con propósito y respaldada por experiencia médica
          real.
        </motion.p>

        {/* Dra. Ysailis */}
        <motion.div className="flex flex-col items-center mb-8" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-244">
          <div className="bg-white p-5 rounded-2xl shadow-md mb-4 w-full max-w-xs h-40 flex items-center justify-center" data-id="element-245">
            <img src={DRA_LOGO} alt="Dra. Ysailis Martínez" className="max-h-32 max-w-full object-contain" data-id="element-246" />
          </div>
          <p className="font-bold text-heading text-lg" data-id="element-247">
            Dra. Ysailis Martinez
          </p>
          <p className="text-sm text-[#8A7F7A] mb-2" data-id="element-248">
            Médico Especialista en Salud Femenina
          </p>
          <a href="https://instagram.com/draysailismartinez" target="_blank" rel="noopener noreferrer" className="font-semibold text-button hover:underline" data-id="element-249">
            📲 @draysailismartinez
          </a>
        </motion.div>

        {/* Divider */}
        <div className="mx-auto my-6" style={{
        width: '60px',
        height: '1px',
        background: '#DCCFEA'
      }} data-id="element-250"></div>

        {/* Profem */}
        <motion.div className="flex flex-col items-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-251">
          <div className="bg-white p-5 rounded-2xl shadow-md mb-4 w-full max-w-xs h-40 flex items-center justify-center" data-id="element-252">
            <img src={PROFEM_LOGO} alt="Centro Médico Especializado Profem" className="max-h-32 max-w-full object-contain" data-id="element-253" />
          </div>
          <p className="font-bold text-heading text-lg" data-id="element-254">
            Centro Médico Especializado Profem
          </p>
          <a href="https://instagram.com/profemm.ccs" target="_blank" rel="noopener noreferrer" className="font-semibold text-button hover:underline mt-2" data-id="element-255">
            📲 @profemm.ccs
          </a>
        </motion.div>

        <p className="text-sm text-[#8A7F7A]" data-id="element-256">
          ¿Tienes dudas sobre tu salud íntima? Consulta con un profesional de
          confianza.
        </p>
      </div>
    </section>;
}